import { render, staticRenderFns } from "./MaterialsSlider.vue?vue&type=template&id=8f7ac23e&scoped=true"
import script from "./MaterialsSlider.vue?vue&type=script&lang=js"
export * from "./MaterialsSlider.vue?vue&type=script&lang=js"
import style0 from "./MaterialsSlider.vue?vue&type=style&index=0&id=8f7ac23e&prod&scoped=true&lang=scss"
import style1 from "./MaterialsSlider.vue?vue&type=style&index=1&id=8f7ac23e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7ac23e",
  null
  
)

export default component.exports